import { DocumentPreview } from 'src/models/document';

import { Callback } from 'src/util/query/models/Callback';

import { SetDocumentPreviewPayload } from '../interfaces';

export class DocumentPreviewCallback extends Callback<DocumentPreview> {
	public constructor(
		private readonly aggregateId: string,
		private readonly setDocumentPreview: (payload: SetDocumentPreviewPayload) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: DocumentPreview): void => {
		this.setDocumentPreview({
			aggregateId: this.aggregateId,
			payload: successResponse,
		});
	};
}
